import React from 'react';

/**
 * Container "burro" para posicionamento absoluto
 * Usado para elementos flutuantes como moderador
 */
export default function AbsoluteContainer({ children, style = {}, ...props }) {
  return (
    <div
      style={{
        position: 'absolute',
        right: 32,
        bottom: 32,
        zIndex: 10,
        ...style
      }}
      {...props}
    >
      {children}
    </div>
  );
}
